import styled from 'styled-components';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { Colors } from '../../../theme';
export const StyledMuiAccordion = styled(MuiAccordion) `
  width: 100%;
  border: 0;

  &:not(:last-child) {
    border-bottom: 0;
  }

  &::before {
    display: none;
  }
`;
export const StyledAccordionSummary = styled(MuiAccordionSummary) `
  padding: 12px 16px;

  .MuiAccordionSummary-expandIconWrapper {
    color: ${Colors.black80};

    .MuiSvgIcon-root {
      font-size: 24px;
    }
  }

  .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: rotate(180deg);
  }

  .MuiAccordionSummary-content {
    margin: 0;
  }
`;
export const StyledAccordionDetails = styled(MuiAccordionDetails) `
  padding: 0;
`;
//# sourceMappingURL=styles.js.map